import React from "react";
import styles from "./FileUploadTabs.module.css";
import i18n from "../../Services/i18n";

const FileUploadTabs = ({
  activeTab,
  onTabChange,
  showMultiImageTab,
  className,
}) => {
  return (
    <div className={`${styles.tabs} ${className ? styles[className] : ""}`}>
      <div
        className={`${styles.tab} ${
          activeTab === "single" ? styles.activeTab : ""
        }`}
        onClick={() => onTabChange("single")}>
        {i18n.t("FileUploaderModal.TabName.SingleFile")}
      </div>
      {showMultiImageTab && (
        <div
          className={`${styles.tab} ${
            activeTab === "multiple" ? styles.activeTab : ""
          }`}
          onClick={() => onTabChange("multiple")}>
          {i18n.t("FileUploaderModal.TabName.MultiFiles")}
        </div>
      )}
      <div
        className={`${styles.tab} ${
          activeTab === "library" ? styles.activeTab : ""
        }`}
        onClick={() => onTabChange("library")}>
        {i18n.t("FileUploaderModal.TabName.FromLibrary")}
      </div>
    </div>
  );
};

export default FileUploadTabs;
